import { queryAll, touchElement } from 'lambda-dom'
import { construct, pluck } from 'ramda'
import { merge, NEVER } from 'rxjs'
import { startWith } from 'rxjs/operators'

import { noop } from '@app-helpers'
import { PublicationsInteractive, SwiperInteractive, YearTabsInteractive } from './interactives'
import { WebcastEventSource, WebcastInteractive, WebcastYearSelection, YearQualifiedElement } from '../investor.types'
import { dataYear } from '../investor.lib'

const noopInteractive = (): WebcastInteractive => ({
    selections$: NEVER,
    source: WebcastEventSource.NEVER,
    reflect: noop,
})

const publications = queryAll<YearQualifiedElement>('.publications__list .publications__publication-year[data-year]')
const publicationsYearTabs = queryAll<YearQualifiedElement>('.publications__year-selector-year[data-year]')
const webcastsYearTabs = queryAll<YearQualifiedElement>('.webcasts__year-selector-year[data-year]')

if (publicationsYearTabs.length && webcastsYearTabs.length) {
    const interactives = [
        new YearTabsInteractive(publicationsYearTabs),
        new PublicationsInteractive(publications),
        new YearTabsInteractive(webcastsYearTabs),
        touchElement('div.webcasts__slider', construct(SwiperInteractive)) || noopInteractive(),
    ]

    merge(...pluck('selections$', interactives)).pipe(
        startWith(<WebcastYearSelection>{
            year: dataYear(publicationsYearTabs[0]),
            source: WebcastEventSource.Manual,
        }),
    ).subscribe((selection) => interactives.forEach((interactive) => interactive.reflect(selection)))
}
